// Google sign-in through Firebase's popup, then the existing
// POST /v1/auth/google, which verifies the ID token and sets the session.
// Firebase is imported only when the button is pressed, so it never weighs
// on the landing page.

// Firebase web config is public by design; it identifies the project, it
// does not authorise anything. Same project as public/social_signin.
const FIREBASE_CONFIG = {
  apiKey: "AIzaSyD8KZfkgGu5FJvGMi7xd1FvKg3ndBHe7LU",
  authDomain: "beatflipz-82be7.firebaseapp.com",
  projectId: "beatflipz-82be7",
  storageBucket: "beatflipz-82be7.appspot.com",
  messagingSenderId: "839557171771",
  appId: "1:839557171771:web:9f7836dee2a00ff0f42a1e",
};

export async function signInWithGoogle(): Promise<void> {
  const [{ getApps, initializeApp }, { getAuth, GoogleAuthProvider, signInWithPopup }] = await Promise.all([
    import("firebase/app"),
    import("firebase/auth"),
  ]);
  const app = getApps()[0] ?? initializeApp(FIREBASE_CONFIG);
  const { user } = await signInWithPopup(getAuth(app), new GoogleAuthProvider());
  const token = await user.getIdToken();
  const res = await fetch("/v1/auth/google", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({
      user: { email: user.email, displayName: user.displayName, photoURL: user.photoURL },
      token,
    }),
  });
  if (!res.ok) throw new Error(`google sign-in ${res.status}`);
}
